import Icon from '../components/Icon.vue'

Icon.register({
  'smile-wink': {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M0 256C0 393 111 504 248 504S496 393 496 256 385 8 248 8 0 119 0 256zM200 208C200 225.7 185.7 240 168 240S136 225.7 136 208 150.3 176 168 176 200 190.3 200 208zM358.5 224.5C343.7 211.3 312.3 211.3 297.5 224.5L288 233C279.7 240.4 266.4 233.4 268.2 222.2 272.2 197 302.4 180.1 328.1 180.1S384 197 388 222.2C389.7 233.3 376.6 240.5 368.2 233L358.5 224.5zM157.8 325.8C180.2 352.7 213 368 248 368S315.8 352.6 338.2 325.8C351.8 309.6 376.3 330 362.8 346.3 334.3 380.4 292.5 400 248 400S161.7 380.4 133.2 346.2C119.7 329.9 144.4 309.5 157.8 325.8z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/smile-wink.js
// module id = pHA3
// module chunks = 144